import { SelectProps } from "@mui/material";
import { CustomMuiSelectProps, MultiOptionsDataType } from "./MuiMultiSelect";

// Reset selected values
export const resetValuesAction = (
  options: MultiOptionsDataType[],
  setSelectedItems: React.Dispatch<React.SetStateAction<(string | number)[]>>,
  setSelectedDataChip: React.Dispatch<
    React.SetStateAction<MultiOptionsDataType[]>
  >,
  setSelectedItem: React.Dispatch<React.SetStateAction<string | number>>,
  values?: string[],
) => {
  if (values?.length) {
    const newValue = values.filter((item) => {
      return options.some((option) => {
        return option.value === item;
      });
    });

    setSelectedItems(newValue);
    setSelectedDataChip(
      newValue
        .map((value) => options.find((option) => option.value === value))
        .filter(Boolean) as MultiOptionsDataType[],
    );
  } else {
    setSelectedItems([]);
    setSelectedDataChip([]);
    setSelectedItem("");
  }
};

export const handleKeyDownAction = (
  event: React.KeyboardEvent<HTMLUListElement>,
  filteredOptions: MultiOptionsDataType[],
  setFocusedIndex: React.Dispatch<React.SetStateAction<number>>,
  itemRefs: React.RefObject<HTMLLIElement[]>,
  focusedIndex: number,
) => {
  if (event.key === "ArrowDown" || event.key === "Tab") {
    event.preventDefault();
    setFocusedIndex((prev) => (prev + 1) % filteredOptions.length);
  } else if (event.key === "ArrowUp") {
    event.preventDefault();
    setFocusedIndex((prev) =>
      prev === 0 ? filteredOptions.length - 1 : prev - 1,
    );
  } else if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    itemRefs.current?.[focusedIndex]?.click();
  }
};

export const getFilteredOptionsByText = (
  options: MultiOptionsDataType[],
  searchText: string,
  showDoubleLabel: boolean,
) => {
  const searchTextLower = searchText.toLowerCase();
  return options.filter((option) => {
    if (showDoubleLabel) {
      return (
        option.label.toLowerCase().includes(searchTextLower) ||
        option.additionalInfo?.toLowerCase().includes(searchTextLower)
      );
    }
    return option.label.toLowerCase().includes(searchTextLower);
  });
};

export const getMergedInputProps = (
  props: CustomMuiSelectProps,
): SelectProps["inputProps"] => {
  return {
    "data-testid": props.id,
    "aria-label": `${props.label} ${props.isMandatory && !props.disabled ? props.allARIAProps.requiredARIALabel : props.selectPlaceHolder}`,
    ...props.inputProps,
  };
};
